export const countryConfigAD = {
  home: {
    skeleton: {
      banner: true,
      bubbles: true,
      featuredProducts: true,
      services: false,
      starredProductLists: 0,
      starredCards1: false,
      starredCards2: false,
      posts: false
    }
  }
};
